import { render, staticRenderFns } from "./WrapperCollapse.vue?vue&type=template&id=ef235e3c&"
import script from "./WrapperCollapse.vue?vue&type=script&lang=js&"
export * from "./WrapperCollapse.vue?vue&type=script&lang=js&"
import style0 from "./WrapperCollapse.vue?vue&type=style&index=0&id=ef235e3c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports